import { IErrorMessage } from '../interfaces'

export const errorMessage: IErrorMessage = {
  DeactivatedUser: 'Your account has been deactivated',
  InvalidEmailOrPassword: 'Your email or password is invalid',
}
